import { FeatureFlagName, UserInterface } from '@/interfaces/User.interface';
import { PermissionType } from '@/constants/types';

export interface MeetingAuthStore {
  user?: UserInterface | null;
  hasFeature?: (flag: FeatureFlagName) => boolean;
  hasPermission?: (permissions: PermissionType[]) => boolean;
}

/**
 * Determines whether the current user has access to Meetings and Relationship Intelligence.
 *
 * Checks:
 * 1. User-level feature flags: 'relationship_intelligence' | 'meetings'
 * 2. Tenant-level flags on user object: canAccessMeetings | canAccessRelationshipIntelligence
 * 3. Specific permissions: 'meetings_view' | 'meeting_view'
 */
export const canAccessMeetings = (authStore?: MeetingAuthStore | null): boolean => {
  if (!authStore) {
    return false;
  }

  // 1. Check user feature flags
  if (
    authStore.hasFeature?.('relationship_intelligence' as FeatureFlagName) ||
    authStore.hasFeature?.('meetings' as FeatureFlagName)
  ) {
    return true;
  }

  // 2. Check tenant flags mapped onto user object
  if (
    Boolean(authStore.user?.canAccessMeetings) ||
    Boolean(authStore.user?.canAccessRelationshipIntelligence)
  ) {
    return true;
  }

  // 3. Check RBAC permissions
  if (
    authStore.hasPermission?.([
      'meetings_view',
      'meeting_view'
    ] as PermissionType[])
  ) {
    return true;
  }

  return false;
};
